import React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';

export default function Container({ className, children, containerRef }) {
  return (
    <div ref={containerRef} className={classNames('container', className)}>
      <div className={'container__block'}>
        <div className={'container__content'}>{children}</div>
      </div>
    </div>
  );
}

Container.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
